import { HEX_FCFDFE } from '@tanium/colors';
import {
  ChartStatusAboveAverage,
  ChartStatusAverage,
  ChartStatusBelowAverage,
  ChartStatusInformational,
  ChartStatusNeedsImprovement,
  ChartStatusNeutral,
  ChartStatusOptimized,
  ChartStatusPending,
  ThemeDefinition,
} from '@tanium/react-theme-definition';

export const AboveAverageFill = ChartStatusAboveAverage;
export const AboveAverageText: ThemeDefinition = () => HEX_FCFDFE;
export const AverageFill = ChartStatusAverage;
export const AverageText: ThemeDefinition = () => HEX_FCFDFE;
export const BelowAverageFill = ChartStatusBelowAverage;
export const BelowAverageText: ThemeDefinition = () => HEX_FCFDFE;
export const InformationalFill = ChartStatusInformational;
export const InformationalText: ThemeDefinition = () => HEX_FCFDFE;
export const NeedsImprovementFill = ChartStatusNeedsImprovement;
export const NeedsImprovementText: ThemeDefinition = () => HEX_FCFDFE;
export const NeutralFill = ChartStatusNeutral;
export const NeutralText: ThemeDefinition = () => HEX_FCFDFE;
export const OptimizedFill = ChartStatusOptimized;
export const OptimizedText: ThemeDefinition = () => HEX_FCFDFE;
export const PendingFill = ChartStatusPending;
export const PendingText: ThemeDefinition = () => HEX_FCFDFE;
